'use client';

/**
 * UploadDialog - 弹窗包装 FileUpload
 */

import { useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useTranslation } from '@/hooks/useTranslation';
import { FileUpload } from './FileUpload';
import type { SingleUploader, UploadQueueItem } from './types';

export interface UploadDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  uploader: SingleUploader;
  /** 全部 settled（含成功/失败/取消）后回调；调用方在这刷新列表 */
  onAllSettled?: (items: UploadQueueItem[]) => void;
  /** 单文件成功 */
  onFileSuccess?: (file: File) => void;
  /** 自定义标题，默认走 i18n attachment.uploadDialogTitle */
  title?: string;
  description?: string;
}

export function UploadDialog({
  open,
  onOpenChange,
  uploader,
  onAllSettled,
  onFileSuccess,
  title,
  description,
}: UploadDialogProps) {
  const { t } = useTranslation();
  const a = t.meetingAttendance.attachment;

  const handleClose = useCallback(() => {
    onOpenChange(false);
  }, [onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title ?? a.uploadDialogTitle}</DialogTitle>
          <DialogDescription>{description ?? a.uploadDialogDescription}</DialogDescription>
        </DialogHeader>
        <FileUpload
          uploader={uploader}
          onAllSettled={onAllSettled}
          onFileSuccess={onFileSuccess}
          onRequestClose={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
}
